import { Button, Drawer, Layout } from "antd";
import { ReactNode, Suspense } from "react";
import AlertIcon from "../assets/icons/AlertIcon";
import SidebarContent from "../components/common/sidebar/SidebarContent";
import SidebarItems from "../components/common/sidebar/SidebarItems";
import Loader from "../components/ui/Loader";
import useSidebar from "../hooks/useSidebar";
import AppLayout from "./AppLayout";

export interface SidebarLayoutProps {
  children?: ReactNode;
  appTitle?: string;
  title?: string;
  contentClass?: string;
  tabList?: {
    label: string;
    link: string;
    redirect?: string;
    disabled?: boolean;
  }[];
}

export default function SidebarLayout({
  children,
  title,
  appTitle,
  tabList,
  contentClass,
}: SidebarLayoutProps) {
  const {
    collapsed,
    openSidebar,
    openMenuKeys,
    handleOpenMenu,
    handleCollapsed,
    handleShowSidebar,
    handleCloseSidebar,
  } = useSidebar();

  const handleVerify = () => {
    // sendVerificationEmail({
    //   email: authInfo?.email,
    // });
  };

  const isEmailVerified = true; // TODO:

  return (
    <div>
      {!isEmailVerified ? (
        <div className="h-12 bg-[#f6ddbc] flex justify-center items-center text-center text-sm font-medium !text-primary sticky z-[999] w-full top-0">
          <AlertIcon />
          <span className="px-2">Your email address isn’t verified yet.</span>
          <Button
            type="primary"
            className="!h-7 !text-xs"
            size="small"
            onClick={handleVerify}
            // loading={isLoading}
          >
            Verify Now
          </Button>
        </div>
      ) : null}
      <Layout>
        <div className="lg:hidden ">
          <Drawer
            placement="left"
            closable={false}
            onClose={handleCloseSidebar}
            open={openSidebar}
            key="left"
            styles={{
              wrapper: { width: "auto" },
              body: { padding: 0, overflowY: "hidden" },
            }}
          >
            <SidebarItems
              collapsed={false}
              openMenuKeys={openMenuKeys}
              handleOpenMenu={handleOpenMenu}
              isMobile
            />
          </Drawer>
        </div>
        <div className="hidden lg:block border-r border-extra-light">
          <SidebarItems
            collapsed={collapsed}
            openMenuKeys={openMenuKeys}
            handleOpenMenu={handleOpenMenu}
          />
        </div>

        {/* Sidebar content is main children component, where show children data. This component contains Header items like: Profile and Notification  */}
        <AppLayout
          title={appTitle || title}
          className={`w-full ${
            collapsed ? "lg:w-[calc(100vw-80px)]" : "lg:w-[calc(100vw-321px)]"
          }`}
        >
          <SidebarContent
            collapsed={collapsed}
            handleCollapsed={handleCollapsed}
            handleShowSidebar={handleShowSidebar}
            title={title}
            tabList={tabList}
            contentClass={contentClass}
          >
            <Suspense fallback={<Loader />}>{children}</Suspense>
          </SidebarContent>
        </AppLayout>
      </Layout>
    </div>
  );
}
